module.exports = __webpack_public_path__ + "img/img4.2a99de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img4.png
// module id = Zbgw
// module chunks = 2